import classNames from 'classnames'
export default function Divider({ bgColor = 'bg-report-skyblue', className }) {
  return <div className={classNames(' mx-auto h-[2px] ', bgColor, className)} />
}
